<template>
  <v-card flat>
    <v-card-title class="subheader py-0">
      <v-icon small class="mr-1" color="indigo">view_list</v-icon>
      知识产权基本信息
      <v-spacer/>
    </v-card-title>
    <v-divider color="indigo"/>
    <v-card-text class="pt-0">
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs6>
            <div class="x-text-field">
              <label>知识产权名称</label>
              <div>{{ item.name }}</div>
            </div>
          </v-flex>
          <v-flex xs3>
            <div class="x-text-field">
              <label>知识产权类型</label>
              <div>{{ !item.type?"": item.type.name }}</div>
            </div>
          </v-flex>
          <v-flex xs3>
            <div class="x-text-field">
              <label>知识产权属地</label>
              <div>{{ affiliationMap[item.affiliation] }}</div>
            </div>
          </v-flex>
          <v-flex xs6>
            <div class="x-text-field">
              <label>归属部门</label>
              <div>{{ !item.department?"" : item.department.name}}</div>
            </div>
          </v-flex>
          <v-flex xs6>
            <div class="x-text-field">
              <label>代理机构</label>
              <div>{{!item.agency? "" : item.agency.name}}</div>
            </div>
          </v-flex>
          <v-flex xs12>
            <x-orgs-view
              label="归属单位列表"
              v-model="item.orgs"
              hint="申请人列表"
            />
          </v-flex>
          <v-flex xs12>
            <x-apps-view
              label="参与人列表"
              v-model="item.apps"
              hint="参与人列表"
            />
          </v-flex>
          <v-flex xs4>
            <div class="x-text-field">
              <label>登记号</label>
              <div>{{item.number}}</div>
            </div>
          </v-flex>
          <v-flex xs4>
            <div class="x-text-field">
              <label>申请时间</label>
              <div>{{item.appDate}}</div>
            </div>
          </v-flex>
          <v-flex xs4>
            <div class="x-text-field">
              <label>授权时间</label>
              <div>{{item.authoredDate}}</div>
            </div>
          </v-flex>
          <v-flex xs4>
            <div class="x-text-field">
              <label>流程状态</label>
              <div>{{!item.processState?"": item.processState.name}}</div>
            </div>
          </v-flex>
          <v-flex xs4>
            <div class="x-text-field">
              <label>流程状态日期</label>
              <div>{{!item.processStateDate?"": item.processStateDate}}</div>
            </div>
          </v-flex>
          <v-flex xs4>
            <div class="x-text-field">
              <label>成果状态</label>
              <div>{{!item.outcomeState?"": item.outcomeState.name}}</div>
            </div>
          </v-flex>
          <v-flex xs4>
            <div class="x-text-field">
              <label>成果登记日</label>
              <div>{{item.submitDate}}</div>
            </div>
          </v-flex>
          <v-flex xs4>
            <div class="x-text-field">
              <label>缴费提醒日</label>
              <div>{{item.paymentDate}}</div>
            </div>
          </v-flex>
          <v-flex xs4>
            <div class="x-text-field">
              <label>备注</label>
              <div>{{item.notes}}</div>
            </div>
          </v-flex>
          <v-flex xs12>
            <div class="x-text-field">
              <label>专利来源</label>
              <div>{{item.source}}</div>
            </div>
          </v-flex>
          <v-flex xs12>
            <div v-if="item.attachments &&  item.attachments.length > 0">
              <p class="my-1">附件列表：</p>
              <v-divider/>
              <ol class="section-list">
                <li v-for="a in item.attachments" :key="a.dbid" class="pt-1">
                  <a :href="`/api/inte/file/${a.dbid}`" target="_blank" class="x-ellipsis">
                    {{a.fileName}}
                    ({{a.size | fileSize }})
                  </a>
                </li>
              </ol>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  import Vue from 'vue'
  import {mapGetters} from 'vuex'
  import XAppsView from './appsView'
  import XOrgsView from './orgsView'
  const baseUri = '/api/inte/intellectualRegist';
  const statusUri = '/api/code/status';

  export default {
    components: {XAppsView,XOrgsView},

    data: () => ({
      uri: baseUri,
      item: {
        status: {},
        actions: []
      },
      affiliationMap:{
        gn: "国内",
        gw: "国外"
      },
      fileUri: '/api/inte/file',
      statusItems: [],
    }),

    // 路由进入前，组件就未完成渲染，不可以使用 this
    beforeRouteEnter(to, from, next) {
      window.console.log("In edit_page beforeRouteEnter");
      const dbid = to.params.dbid;

      if (dbid) {
        Vue.axios.get(`${baseUri}/${dbid}`)
          .then(
            rsp => next(vm => {
              vm.dbid = dbid;
              vm.item = rsp.data;
              // 保存默认数据
              vm.defaultItem = window.xutil.clone(vm.item);
              vm.loading = false
            })
          )
      } else {
        next();
      }
    },

    // 路由改变前，组件就已经渲染完成，可以使用 this
    beforeRouteUpdate(to, from, next) {
      window.console.log("In edit_page beforeRouteUpdate");

      const dbid = to.params.dbid;
      if (dbid) {
        this.loading = true;
        Vue.axios.get(`${baseUri}/${dbid}`)
          .then(
            rsp => {
              this.dbid = dbid;
              this.item = rsp.data;
              // 保存默认数据
              this.defaultItem = window.xutil.clone(this.item);
              this.loading = false;
              next()
            }
          )
      } else {
        next();
      }
    },

    computed: {
      ...mapGetters(['funcIds'])
    },

    created() {
      // 加载审核状态
      this.axios.get(statusUri, {params: {sort: 'rank.asc'}})
        .then(
          rspStaus => {
            this.statusItems = rspStaus.data.items;
          }
        )
    },

    methods: {
    }
  }
</script>
<style>
  div.dense table.datatable.table td:first-child,
  div.dense table.datatable.table td:not(:first-child),
  div.dense table.datatable.table th:first-child,
  div.dense table.datatable.table th:not(:first-child) {
    padding: 0 8px;
  }
</style>
